import { Article, ArticleClientMapping } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const loadArticlesSuccess = createAction(
  '[Articles/API] Load Articles Success',
  props<{ articles: Article[] }>(),
);

export const getArticle = createAction(
  '[Article/API] Get Article',
  props<{
    articleId: string;
    batchIds: string[] | null;
    rootArticleId: string | null;
    rootBatchId: string | null;
  }>(),
);

export const setArticle = createAction(
  '[Article/API] Set Article',
  props<{
    article: Article | null;
  }>(),
);

export const getClientByArticleNumber = createAction(
  '[Article/API] Get Client By Article Number',
  props<{
    articleNumber: string;
  }>(),
);

export const getClientByArticleNumberSuccess = createAction(
  '[Article/API] Get Client By Article Number Success',
  props<{
    clients: ArticleClientMapping[] | null;
  }>(),
);

export const getArticlesByClientId = createAction(
  '[Article/API] Get Articles By Client Id',
  props<{
    clientId: string;
  }>(),
);

export const getArticlesByClientIdSuccess = createAction(
  '[Article/API] Get Articles By Client Id Success',
  props<{
    articles: Article[] | null;
  }>(),
);

export const setArticlesByClientIdLoading = createAction(
  '[Article/API] Set Articles By Client Id Loading',
  props<{
    loading: boolean;
  }>(),
);

export const removeArticleClientMapping = createAction(
  '[Article/API] Remove Article Client Mapping',
  props<{
    articleId: string;
    clientId: string;
    companyCode: string;
  }>(),
);

export const removeArticleClientMappingSuccess = createAction(
  '[Article/API] Remove Article Client Mapping Success',
  props<{
    articleId: string | undefined;
    clientId: string | undefined;
    companyCode: string | undefined;
  }>(),
);

export const addArticleClientMapping = createAction(
  '[Article/API] Add Article Client Mapping',
  props<{
    articleId: string;
    clientId: string;
    companyCode: string;
  }>(),
);

export const addArticleClientMappingSuccess = createAction(
  '[Article/API] Add Article Client Mapping Success',
  props<{ mapping: ArticleClientMapping | null }>(),
);

export const getClientInfoWithFilters = createAction(
  '[Article/API] Get Client Info With Filters',
  props<{
    articleId?: string;
    clientId?: string;
    companyCode?: string;
  }>(),
);

export const getClientInfoWithFiltersSuccess = createAction(
  '[Article/API] Get Client Info With Filters Success',
  props<{
    clients: ArticleClientMapping[] | null;
  }>(),
);

export const setClientInfoFiltersLoading = createAction(
  '[Article/API] Set Client Info Filters Loading',
  props<{
    loading: boolean;
  }>(),
);
